import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f2a30c88"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"padding":"16px","height":"100%","display":"flex","flex-direction":"column","justify-content":"space-between","box-sizing":"border-box"}
}
const _hoisted_2 = {
  class: "cm-align-center",
  style: {"flex":"1"}
}
const _hoisted_3 = { class: "cm-align-center" }

import { formLabelStyle } from '@/components/cmForm/globalOpt'
import CmForm from '@/components/cmForm/index.vue'
import { FormActionType, FormSize, FormType } from '@/components/cmForm/types'
import { PermissionFe } from '@/services/service-permission.service'
import { formatMapToOptions } from '@/utils/tool'
import PolicyBindScope from '@/views/dashboard/policy/_components/policy-bind-scope.vue'
import { policyBindScopeFormRules } from '@/views/dashboard/policy/_components/policy-bind-scope-form-rule'
import { PolicySettingType, PolicyType, } from '@/views/dashboard/_enum/policy-type'
import { SaveSettingsReq, } from '@/views/dashboard/policy/policy-common.service'
import { ElMessage } from 'element-plus'
import { computed, nextTick, PropType, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'
import { Auth_method, frequencyState } from '../types'
import TaskTimeEdit from '@/views/dashboard/_components/task-time/task-time-edit.vue'
import { DefaultEndTaskTime } from '@/views/dashboard/_components/task-time/task-time.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'strategy-setting',
  props: {
  api: {
    type: Object as PropType<{
      saveOrUpdateApi: (data: SaveSettingsReq) => Promise<void>;
      getApi: ({ id, type }: { id: string; type: PolicySettingType }) => Promise<void>;
    }>,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
  hasPermission: {
    type: Boolean,
    default: false,
  },
  fromGroupId: {
    type: Number,
  },
},
  emits: ['update:modelValue', 'refresh', 'submit'],
  setup(__props, { emit: __emit }) {

const { t, locale } = useI18n()
const passwordRegex = new RegExp('^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,32}$')
const validatePass = (rule, value, callback) => {
  if (!value) {
    callback()
    return
  }
  if (!passwordRegex.test(value)) {
    callback(new Error(t('remoteAuth.passwordRuleError')))
    return
  }
  callback()
}
const props = __props

// 表单的禁用/启用
const disabled = ref(!props.hasPermission)
// 表单实例对象
const formRef = ref()
// 表单的提交loading
const loading = ref(false)
const loadingPage = ref(false)
const strategyOver = ref({ type: PolicyType.remote_login_auth, current: '' })
// 默认表单
const defaultFormData = {
  name: '', group_ids: [], bind_mode: 0, device_ids: [] as string[], auth_type: Auth_method.password, ip_whitelist: '', frequency: frequencyState.day, regular_tasks: [...DefaultEndTaskTime]
}
// 表单数据
const form: any = ref(defaultFormData)

const frequencyStateLabelI18n = computed(() => ({
  [frequencyState.day]: t('remoteAuth.frequencyDay'),
  [frequencyState.week]: t('remoteAuth.frequencyWeek'),
  [frequencyState.month]: t('remoteAuth.frequencyMonth'),
}))

const authMethodLabelForForm = computed(() => {
  const full = {
    [Auth_method.password]: t('remoteAuth.authPasswordOption'),
    [Auth_method.auth_code]: t('remoteAuth.authTokenOption'),
  }
  if (!IS_JP_ONLY_BUILD) return full
  return { [Auth_method.password]: full[Auth_method.password] }
})
const authMethodSubtitleForForm = computed(() => {
  const full = {
    [Auth_method.password]: t('remoteAuth.authPasswordOptionSubtitle'),
    [Auth_method.auth_code]: t('remoteAuth.authTokenOptionSubtitle'),
  }
  if (!IS_JP_ONLY_BUILD) return full
  return { [Auth_method.password]: full[Auth_method.password] }
})

// 表单项配置
const formColumns = computed(() => {
  void locale.value
  return {
    name: { label: t('remoteAuth.policyName'), required: true, inputOpt: { maxlength: 50 }, colOpt: { span: 10 }, },
    auth_type: { label: t('remoteAuth.authMethodLabel'), type: FormType.Radio, radioGroupOpt: { class: 'auth_type-radio-group' }, dictData: formatMapToOptions(authMethodLabelForForm.value, true), radioHtmlText: (label, value) => `<div style=${formLabelStyle}><span>${label}</span> <span style="color: gray">(${authMethodSubtitleForForm.value[value] ?? ''})</span> </div>`, required: true, colOpt: { span: 24 }, },
    password: {
      label: t('remoteAuth.setPassword'), hidden: () => form.value.auth_type !== 1, colOpt: { span: 14 }, placeholder: t('remoteAuth.passwordPlaceholder'), inputOpt: { 'show-password': true, autocomplete: 'new-password' }, modelModifiers: { trim: true },
      inputType: 'password', required: true, rules: [{ custom: { validator: validatePass }, trigger: ['blur', 'change'] }],
    },
    frequency: {
      label: t('remoteAuth.policyExecuteFreq'), required: false, type: FormType.Radio, dictData: formatMapToOptions(frequencyStateLabelI18n.value, true), events: {
        change() {
          form.value.regular_tasks = [...DefaultEndTaskTime]
        }
      }
    },
    regular_tasks: { label: t('remoteAuth.policyExecuteTime'), required: false, slot: true },
    ip_whitelist: { label: t('remoteAuth.remoteTrustIpWhitelist'), modelModifiers: { trim: true }, inputType: 'textarea', tipContent: t('remoteAuth.ipWhitelistTip'), placeholder: t('remoteAuth.ipWhitelistPlaceholder') },
    group_ids: {
      required: false,
      label: t('policyBindScope.applyMode'),
      prop: 'group_ids',
      formItemOpt: { required: false },
      rules: policyBindScopeFormRules(() => form.value, t),
      labelSlot: true,
      slot: true,
      colOpt: { span: 24 },
    },
  }
})
const emits = __emit
const visible = computed({
  get: () => props.modelValue,
  set: (value) => {
    emits('update:modelValue', value)
  },
})
const cancel = () => {
  visible.value = false
  handleReset();
}
const validateTree = () => {
  formRef.value?.ruleFormRef?.validateField?.('group_ids')
}

// 表单重置
const handleReset = async () => {
  form.value = { ...defaultFormData }
}
// 表单数据提交
const handleSubmit = async () => {
  const valid = await formRef.value.handleSubmit()
  if (!valid) return
  const bm = form.value.bind_mode ?? 0
  loadingPage.value = true
  loading.value = disabled.value = true
  const formCopy = { ...form.value }
  delete formCopy.name
  delete formCopy.id
  delete formCopy.group_ids
  if(!formCopy.ip_whitelist || !formCopy.ip_whitelist.length){
    formCopy.ip_whitelist = []
  }
  if (!Array.isArray(formCopy.ip_whitelist)) { formCopy.ip_whitelist = formCopy.ip_whitelist.split(',')?.filter?.(item => Boolean(item)) }
  const strategy = { ...formCopy }
  const formData: SaveSettingsReq = {
    name: form.value.name,
    group_ids: form.value.group_ids,
    device_ids: form.value.device_ids || [],
    bind_mode: bm,
    id: form.value.id,
    type: PolicySettingType.remote_login_auth,
    strategy_type: PolicyType.remote_login_auth,
    strategy: JSON.stringify(strategy),
  }
  console.log('formData :>> ', formData);
  const result: any = await props.api.saveOrUpdateApi(formData).finally(() => loading.value = loadingPage.value = disabled.value = false)
  const ok = result?.resp_common?.msg === 'ok'
  ElMessage({
    type: ok ? 'success' : 'error',
    message: ok ? t('remoteAuth.operateSuccess') : t('remoteAuth.operateFailed'),
  })
  if (ok) {
    emits('refresh')
    if(!form.value.id && form.value.auth_type === Auth_method.auth_code){
      emits('submit',result.id, formData.name)
    }
    visible.value = false
    form.value.id = undefined
  }
}
watch(
  () => props.modelValue,
  async (nv, ov) => {
    handleReset()
    if (nv && props.id) {
      loadingPage.value = true
      strategyOver.value.current = props.id
      const result: any = await props.api.getApi({
        id: props.id,
        type: PolicySettingType.remote_login_auth,
      })
      form.value = {
        name: result.name,
        ...result.strategy,
        group_ids: result.strategy_group_ids,
        bind_mode: result.bind_mode ?? 0,
        device_ids: result.device_ids ?? [],
        id: props.id,
      }
      if (IS_JP_ONLY_BUILD && form.value.auth_type === Auth_method.auth_code) {
        form.value.auth_type = Auth_method.password
      }
      loadingPage.value = false
      console.log('form.value :>> ', form.value);
    }
  },
  {
    immediate: true,
  },
)

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (visible.value)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(CmForm, {
          formSize: _unref(FormSize).Small,
          ref_key: "formRef",
          ref: formRef,
          style: {"flex":"1","overflow-y":"auto","overflow-x":"hidden"},
          modelValue: form.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form).value = $event)),
          formType: _unref(FormActionType).Other,
          "onUpdate:formType": _cache[4] || (_cache[4] = ($event: any) => ((_unref(FormActionType).Other) = $event)),
          disabled: disabled.value,
          "onUpdate:disabled": _cache[5] || (_cache[5] = ($event: any) => ((disabled).value = $event)),
          formColumns: formColumns.value,
          formOpt: { 'label-width': 'auto', labelPosition: 'left' },
          opeRowOpt: { justify: 'start', style: { marginTop: '20px' } },
          onReset: _cache[6] || (_cache[6] = () => (visible.value = false)),
          rowOpt: { style: { display: 'grid' }, class: 'gap-20' }
        }, {
          group_ids: _withCtx(() => [
            _createVNode(PolicyBindScope, {
              "bind-mode": form.value.bind_mode ?? 0,
              "group-ids": form.value.group_ids || [],
              "device-ids": form.value.device_ids || [],
              "preset-group-id": form.value.id ? undefined : __props.fromGroupId,
              "permission-key": _unref(PermissionFe).remote_control,
              "strategy-over": strategyOver.value,
              disabled: disabled.value,
              "onUpdate:bindMode": _cache[0] || (_cache[0] = 
            (v) => {
              form.value.bind_mode = v
              nextTick(() => validateTree())
            }
          ),
              "onUpdate:groupIds": _cache[1] || (_cache[1] = ($event: any) => (form.value.group_ids = $event)),
              "onUpdate:deviceIds": _cache[2] || (_cache[2] = 
            (v) => {
              form.value.device_ids = v
              nextTick(() => validateTree())
            }
          ),
              onGroupUpdate: validateTree
            }, null, 8, ["bind-mode", "group-ids", "device-ids", "preset-group-id", "permission-key", "strategy-over", "disabled"])
          ]),
          "group_ids-label": _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                style: _normalizeStyle(_unref(formLabelStyle))
              }, _toDisplayString(_ctx.$t('policyBindScope.applyMode')), 5)
            ])
          ]),
          regular_tasks: _withCtx(({ prop }) => [
            _createVNode(TaskTimeEdit, {
              modelValue: form.value[prop],
              "onUpdate:modelValue": ($event: any) => ((form.value[prop]) = $event),
              "main-switch": true,
              "mix-type": form.value.frequency,
              "default-end-min": 23 * 60 + 50
            }, null, 8, ["modelValue", "onUpdate:modelValue", "mix-type"])
          ]),
          _: 1
        }, 8, ["formSize", "modelValue", "formType", "disabled", "formColumns"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            onClick: cancel,
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (handleSubmit())),
            loading: loading.value,
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])), [
        [_directive_loading, loadingPage.value]
      ])
    : _createCommentVNode("", true)
}
}

})